import api from './api';
import { setStorage, removeStorage } from './localstorage';

export const login = async (username, password) => {
  try {
    const userPass = `${username} ${password}`;
    const base64data = btoa(userPass);

    // Send POST request
    const { data } = await api.post(
      `${process.env.REACT_APP_APIHOST}/login_user`,
      {
        source: base64data,
      },
    );
    console.log('data :>> ', data);
    const token = data?.token;
    console.log('token :>> ', token);
    await setStorage('token', token);
    await setStorage('merchantName', data.MERCHANT_NAME);
    await setStorage(
      'username',
      `${data.first_name_eng} ${data.last_name_eng}`,
    );
    await setStorage('email', `${data.email}`);
  } catch (e) {
    throw new Error(e);
  }
};

export const loginAdmin = async (username, password) => {
  try {
    const userPass = `${username} ${password}`;
    const base64data = btoa(userPass);

    const { data } = await api.post(
      `${process.env.REACT_APP_APIHOST}/login_admin`,
      {
        source: base64data,
      },
    );

    const token = data?.token;
    console.log('data :>> ', data);
    console.log('token :>> ', token);
    await setStorage('token', token);
    await setStorage('merchantName', data.MERCHANT_NAME);
    await setStorage(
      'username',
      `${data.first_name_eng} ${data.last_name_eng}`,
    );
    await setStorage('email', `${data.email}`);
  } catch (e) {
    throw new Error(e);
  }
};
export const loginEEntry = async (username, password) => {
  try {
    const userPass = `${username} ${password}`;
    const base64data = btoa(userPass);

    // Send POST request
    const { data } = await api.post(
      `${process.env.REACT_APP_APIHOST}/eentry/login`,
      {
        source: base64data,
      },
    );
    console.log('data :>> ', data);
    const token = data?.token;
    console.log('token :>> ', token);
    await setStorage('token', token);
    await setStorage('merchantName', data.MERCHANT_NAME);
    await setStorage(
      'username',
      `${data.first_name_eng} ${data.last_name_eng}`,
    );
    await setStorage('email', `${data.email}`);
  } catch (e) {
    throw new Error(e);
  }
};
export const loginEDonation = async (username, password) => {
  try {
    const userPass = `${username} ${password}`;
    const base64data = btoa(userPass);

    // Send POST request
    const { data } = await api.post(
      `${process.env.REACT_APP_APIHOST}/eentry/login`,
      {
        source: base64data,
      },
    );
    console.log('data :>> ', data);
    const token = data?.token;
    console.log('token :>> ', token);
    await setStorage('token', token);
    await setStorage('eDoanation', 'E-Donation');
    await setStorage('merchantName', data.MERCHANT_NAME);
    await setStorage(
      'username',
      `${data.first_name_eng} ${data.last_name_eng}`,
    );
    await setStorage('email', `${data.email}`);
  } catch (e) {
    throw new Error(e);
  }
};

export const loginAdminEEntry = async (username, password) => {
  try {
    const userPass = `${username} ${password}`;
    const base64data = btoa(userPass);

    const { data } = await api.post(
      `${process.env.REACT_APP_APIHOST}/eentry/login-superadmin`,
      {
        source: base64data,
      },
    );

    const token = data?.token;
    console.log('data :>> ', data);
    console.log('token :>> ', token);
    await setStorage('token', token);
    await setStorage('merchantName', data.MERCHANT_NAME);
    await setStorage(
      'username',
      `${data.first_name_eng} ${data.last_name_eng}`,
    );
    await setStorage('email', `${data.email}`);
  } catch (e) {
    throw new Error(e);
  }
};

export const logout = async () => {
  removeStorage('token');
  removeStorage('remember');
};
